import { defineStore } from 'pinia';
// @ts-ignore
import { useStore } from 'vuex';

import type { Toast } from '@/components/notifications-fi/toast-notification-fi/toast-notification-item-fi/ToastNotificationItemFi.vue';
import { useDict } from '@/composables/fischerPlugin';

export const useNotificationStore = defineStore('useNotificationStore', {
  state() {
    const store = useStore();
    const dict = useDict();

    const openToastNotification = (notification: Toast) =>
      store.dispatch('notifications/openToastNotification', notification);

    const openGeneralErrorNotification = () =>
      store.dispatch('notifications/openGeneralErrorNotification', { dict });

    const clearToastNotifications = () => store.dispatch('notifications/clearToastNotifications');

    return { openToastNotification, openGeneralErrorNotification, clearToastNotifications };
  },
});
